import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/app.css'
import { bootstrap } from './api/client'
import App from './App.tsx'
import { initialScreen, recallDeepLink, rememberDeepLink } from './lib/startup'
import { SignedOut } from './screens/SignedOut'

const root = createRoot(document.getElementById('root')!)

function session(): Storage | null {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

// Read the runtime configuration and complete sign-in before the app renders - nothing in the
// shell has to cope with "not signed in yet". A failure here is terminal and says so.
root.render(
  <StrictMode>
    <main>
      <p className="loading">Signing in…</p>
    </main>
  </StrictMode>,
)

// The sign-in redirect drops the query string, so `?order=<id>` is kept across it (a sign-in that
// starts mid-session also carries it as `url_state`, see api/auth.ts). Only a link to a screen is
// kept: the page sign-in returns to carries its own query (`?code=&state=`), which must not replace it.
const storage = session()
if (storage && initialScreen(window.location.search).screen !== 'new') rememberDeepLink(storage, window.location.search)

bootstrap().then(
  (result) => {
    // Straight after "Sign out": no automatic sign-in (it would complete silently, see SignedOut).
    if (result === 'signed-out') {
      root.render(
        <StrictMode>
          <SignedOut />
        </StrictMode>,
      )
      return
    }
    const deepLink = storage ? recallDeepLink(storage) : null
    if (deepLink && window.location.search === '') {
      window.history.replaceState(null, '', `${window.location.pathname}${deepLink}`)
    }
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  },
  (e: unknown) => {
    const message = e instanceof Error ? e.message : String(e)
    root.render(
      <StrictMode>
        <main>
          <div className="card">
            <h2 data-icon="error">Glasses Orders could not start</h2>
            <p>{message}</p>
            <p>Reload the page. If it keeps happening, tell the administrator what this said.</p>
          </div>
        </main>
      </StrictMode>,
    )
  },
)
